import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import PrimaryButton from "shared/components/PrimaryButton";
import {
  COLOR_BORDER,
  COLOR_WHITE,
  COLOR_GREY_4,
  COLOR_BLACK_5,
} from "shared/theme/colors";
import { flex, border } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ fd: "column", jc: "center" })};
  ${border(1, COLOR_BORDER)};
  border-radius: 1rem;
  background-color: ${COLOR_WHITE};
  padding: 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 24px 0 ${COLOR_BLACK_5};

  :last-child {
    margin-bottom: 0;
  }
`;

export const StyledContentSectionButton = styled(PrimaryButton, {
  shouldForwardProp: (props) =>
    props !== "disabled" && props !== "styleAddButton" && props !== "textColor",
})<{
  textColor?: string;
  styleAddButton?: boolean;
  disabled?: boolean;
}>`
  .MuiButton-root {
    cursor: pointer;
  }

  ${(props) =>
    props.styleAddButton &&
    `&.MuiButton-textPrimary {
    color: ${props.disabled ? COLOR_GREY_4 : props.textColor};
    height: 1.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
  }`}
`;

export const StyledArrowIconWrapper = styled(Box, {
  shouldForwardProp: (props) => props !== "open",
})<{
  open: boolean;
}>`
  transform: ${(props) => (props.open ? "rotate(-90deg)" : "rotate(90deg)")};
  cursor: pointer;
`;
